@if (row.importResult && !row.description) {
<div>
  {{
    'csvImport.saveCart.importDesc'
      | cxTranslate : { importRef: row.importResult.importRef, importSuccess: row.importResult.importSuccess }
  }}
  @if (row.importResult.importFailed) {
  <span>
    {{ 'csvImport.saveCart.importDescFailed' | cxTranslate }}
    <button class="tertiary-btn btn js-saved-cart-desc-error" style="height: auto" (click)="openError(row.code)">
      {{ 'csvImport.saveCart.importDescFailedNumber' | cxTranslate : { importFailed: row.importResult.importFailed } }}
    </button>
  </span>
  }
</div>
} @else {
<div class="cart-list-description" [innerText]="row.description"></div>
}
